import React from "react";

const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
    <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="1.728">
      <ellipse cx="5.71" cy="5.629" rx="5.462" ry="5.384" transform="translate(3 .735)" />
      <path d="M16.492 19.57c0-4.123-3.39-7.466-7.574-7.466-4.183 0-7.574 3.343-7.574 7.466" />
    </g>
  </svg>
);

export default UserIcon;
